<button pButton
        icon="fa-solid fa-phone"
        class="p-button-text"
        [class.p-button-danger]="loadingError"
        (click)="fastDialPanel.show($event)"
        [disabled]="loadingError"
        [loading]="loading"
        [pTooltip]="loadingError ? 'Errore durante il caricamento dei numeri fornitore' : null"
></button>

<app-popover #fastDialPanel>
    <div style="min-width: 300px">
        <h3>Numeri fornitori</h3>
        <p-table [value]="numbers" >
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td class="text-left">{{obj(item).name}}</td>
                    <td class="text-right">
                        <a [href]="'tel:' + obj(item).telephone" [pTooltip]="'Chiama ' + obj(item).name">
                            {{obj(item).telephone}}
                        </a>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div *appAcl="AclPermission.EditFastDialNumbers"
             class="flex justify-content-end mt-5">
            <a class="hidden md:block"
                [routerLink]="[Routing.fastDialNumbers.getBasePath()]">
                Modifica numeri fornitori</a>
        </div>
    </div>
</app-popover>
